import { SVGProps } from "react";

export const MissingInfoWarningIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M13.79 10.5583L8.30667 1.33C8.0325 0.863333 7.54833 0.583333 7 0.583333C6.45167 0.583333 5.9675 0.863333 5.69917 1.33L0.21 10.5583C-0.0641669 11.0367 -0.0641669 11.6025 0.21 12.075C0.484166 12.5475 0.974167 12.8333 1.51667 12.8333H12.4892C13.0375 12.8333 13.5275 12.5475 13.7958 12.075C14.0642 11.6025 14.0642 11.0367 13.79 10.5583ZM12.7867 11.4917C12.7575 11.5442 12.67 11.6608 12.4892 11.6608H1.51083C1.33 11.6608 1.2425 11.5383 1.21333 11.4917C1.18417 11.445 1.12583 11.305 1.21333 11.1475L6.7025 1.91917C6.79 1.7675 6.94167 1.75 7 1.75C7.05833 1.75 7.20417 1.7675 7.2975 1.925L12.7808 11.1533C12.8742 11.305 12.81 11.445 12.7808 11.4975L12.7867 11.4917ZM6.41667 4.66667H7.58333V8.16667H6.41667V4.66667ZM6.41667 9.33333H7.58333V10.5H6.41667V9.33333Z"
      fill="#99601F"
    />
  </svg>
);
